<template>
  <FormSection
    :title="$t('APP.SALES_REPORT.TITLE')"
    :description="$t('APP.SALES_REPORT.DESCRIPTION')"
  >
    <Card>
      <ElForm label-position="top">
        <ElFormItem :label="$t('FROM_DATE')">
          <UiDatePicker
            :default-date="lastMonthDate"
            @select-date="setFromDate"
          />
        </ElFormItem>

        <ElFormItem :label="$t('TO_DATE')">
          <UiDatePicker :default-date="currentDate" @select-date="setToDate" />
        </ElFormItem>

        <AppSalesReportsSendToEmailButton
          :title="$t('ADVERTISEMENT.FINANCE.SALES_FILE.SEND_TO_EMAIL')"
          :loading="isFileSendingToEmail"
          @sendToEmail="sendToEmail"
        />
      </ElForm>
    </Card>
  </FormSection>
</template>

<script>
import { AppSalesReport } from '@/api/api';

import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';

import packageName from '@/mixins/packageName';

import UiDatePicker from '@@/layout/UiDatePicker';

import AppSalesReportsSendToEmailButton from './AppSalesReportsSendToEmailButton';

export default {
  name: 'AppSalesReportForm',

  components: {
    FormSection,
    Card,
    UiDatePicker,
    AppSalesReportsSendToEmailButton,
  },

  mixins: [packageName],

  data() {
    return {
      dateRange: {
        from: '',
        to: '',
      },
      isFileSendingToEmail: false,
    };
  },

  computed: {
    lastMonthDate() {
      const date = new Date();
      return date.setMonth(date.getMonth() - 1);
    },
    currentDate() {
      return Date.now();
    },
  },

  methods: {
    sendToEmail(email) {
      this.isFileSendingToEmail = true;

      return AppSalesReport.sendAppSalesReportToEmail({
        packageName: this.packageName,
        range: this.dateRange,
        email,
      })
        .then(() => {
          this.$message.success(
            this.$t('ADVERTISEMENT.FINANCE.SEND_TO_EMAIL.SUCCESSFUL'),
          );
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isFileSendingToEmail = false;
        });
    },

    setFromDate(selectedDate) {
      this.dateRange.from = selectedDate;
    },

    setToDate(selectedDate) {
      this.dateRange.to = selectedDate;
    },
  },
};
</script>
